import * as React from "react";
import {MouseEvent} from "react";
import {ChildrenType} from "../../_definitions/styleteq";
import {ResourceType} from "../../_helpers/data";
import * as classNames from "classnames";

interface Props {
    id: number;
    className: string;
    click: (id: number, e: MouseEvent<HTMLElement>, type: string) => void;
    element: string;
    type: string;
    children: ChildrenType;
}

const UserRedirectComponent = (props: Props) => {
    const {children, click, className, id, element, type} = props;

    let t = !type ? ResourceType.user : type;

    if (element == 'a') {
        return (
            <a onClick={(e) => click(id, e, t)} className={className}>
                {children}
            </a>
        );
    }
    else if (element == 'div') {
        return (
            <div onClick={(e) => click(id, e, t)} className={classNames('link-cursor',className)}>
                {children}
            </div>
        );
    }
    else if (element == 'b') {
        return (
            <b onClick={(e) => click(id, e, t)} className={classNames('link-cursor',className)}>
                {children}
            </b>
        );
    }
    return null;
};
export default UserRedirectComponent;


// WEBPACK FOOTER //
// ./app/client/_widgets/user/UserRedirectComponent.tsx